/* eslint-disable max-len */
import universal from 'react-universal-component';

export const ExperimentModal = universal(
	import(/* webpackChunkName: "ExperimentModal" */ './ExperimentModal'),
);
